import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu } from "lucide-react";
import { toAbsoluteUrl } from "../../_helpers";
import { AsideMenuList } from "./aside/aside-menu/AsideMenuList";
import "../../../app/layout/shell.scss";

// Stub — AsideMenuList only reads `.ulClasses` off this, which Metronic's
// uiService used to populate. Not needed now that the shell isn't Metronic.
const ASIDE_MENU_LAYOUT_PROPS = { ulClasses: "" };

export function Layout({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="sety-shell">
      <aside className={`sety-sidebar${mobileOpen ? " sety-sidebar--open" : ""}`}>
        <Link to="" className="sety-sidebar__brand" onClick={() => setMobileOpen(false)}>
          <img alt="Sety" src={toAbsoluteUrl("/media/logos/Logo.svg")} />
        </Link>
        <div className="sety-sidebar__menu">
          <AsideMenuList layoutProps={ASIDE_MENU_LAYOUT_PROPS} />
        </div>
      </aside>

      {mobileOpen && (
        <div className="sety-mobile-backdrop" onClick={() => setMobileOpen(false)} />
      )}

      <main className="sety-main">
        <div className="sety-mobile-topbar">
          <button
            className="sety-mobile-topbar__toggle"
            onClick={() => setMobileOpen(true)}
            aria-label="Open menu"
          >
            <Menu size={20} />
          </button>
          <img alt="Sety" className="sety-mobile-topbar__logo" src={toAbsoluteUrl("/media/logos/Logo.svg")} />
        </div>

        <div className="sety-content">
          {children}
        </div>
      </main>
    </div>
  );
}
